(() => {
  try {
    const navbar = document.querySelector("nav.navbar");
    const update = () => {
      let h = 0;
      if (navbar) {
        h = navbar.getBoundingClientRect().height;
      }
      document.documentElement.style.setProperty(
        "--b5-navbar-offset",
        h + "px"
      );
    };
    window.addEventListener("load", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  } catch (e) {}

  // Compute total sticky offset (navbar CSS var + Drupal toolbar if present)
  const getStickyOffset = () => {
    let offset = 0;
    try {
      const cssVar = getComputedStyle(
        document.documentElement
      ).getPropertyValue("--b5-navbar-offset");
      const fromVar = parseInt(cssVar, 10);
      if (!isNaN(fromVar)) offset = fromVar;
    } catch (e) {}
    if (!offset) {
      const nb = document.querySelector("nav.navbar");
      if (nb) offset += nb.getBoundingClientRect().height;
    }
    const drupalToolbar = document.getElementById("toolbar-bar");
    if (drupalToolbar && drupalToolbar.offsetHeight)
      offset += drupalToolbar.offsetHeight;
    return offset;
  };
  const getVisibleCenterAbsoluteY = () => {
    const offset = getStickyOffset();
    const visibleHeight = Math.max(0, window.innerHeight - offset);
    return window.scrollY + offset + visibleHeight / 2;
  };
  const getAnchorForButton = (btn) => {
    if (!btn || !btn.closest) return null;
    return (
      btn.closest(".tabs-project-sticky") ||
      btn.closest(".tabs-project") ||
      null
    );
  };
  const getAnchorBottomAbsoluteY = (anchor) => {
    if (!anchor) return 0;
    const rect = anchor.getBoundingClientRect();
    return Math.round(rect.top + window.scrollY + anchor.offsetHeight);
  };
  const throttle = (fn, wait) => {
    let last = 0;
    let timer = null;
    return (...args) => {
      const now = Date.now();
      const remaining = wait - (now - last);
      if (remaining <= 0) {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        last = now;
        fn.apply(null, args);
      } else if (!timer) {
        timer = setTimeout(() => {
          last = Date.now();
          timer = null;
          fn.apply(null, args);
        }, remaining);
      }
    };
  };
  let isRestoring = false;

  // ---------- Smooth underline indicator ----------
  const updateIndicator = () => {
    try {
      const active = document.querySelector(".tabs-project .nav-link.active");
      if (!active) return;
      const container = active.closest(".tabs-project-sticky");
      if (!container) return;
      const cRect = container.getBoundingClientRect();
      const aRect = active.getBoundingClientRect();
      const left = aRect.left - cRect.left + container.scrollLeft;
      const width = aRect.width;
      container.style.setProperty("--indicator-left", left + "px");
      container.style.setProperty("--indicator-width", width + "px");
    } catch (e) {}
  };
  const scheduleIndicator = throttle(updateIndicator, 16);
  window.addEventListener("load", scheduleIndicator, { passive: true });
  window.addEventListener("resize", scheduleIndicator, { passive: true });

  // Update when tabs change

  document.addEventListener("shown.bs.tab", scheduleIndicator);
  document.addEventListener("click", (ev) => {
    if (
      ev.target &&
      ev.target.closest &&
      ev.target.closest(".tabs-project .nav-link")
    ) {
      scheduleIndicator();
    }
  });

  // Update on horizontal scroll of tabs container

  document.querySelectorAll(".tabs-project-sticky").forEach((el) => {
    el.addEventListener("scroll", scheduleIndicator, { passive: true });
  });
  // ---------- End indicator logic ----------

  // Keep active tab button inside horizontal viewport of the sticky container
  // Use manual horizontal scrolling to avoid page-level scroll jumps.
  const scrollTabIntoView = (btn) => {
    if (!btn) return;
    const container = btn.closest(".tabs-project-sticky");
    if (!container) return;
    const cRect = container.getBoundingClientRect();
    const bRect = btn.getBoundingClientRect();
    const containerCenter = cRect.left + cRect.width / 2;
    const buttonCenter = bRect.left + bRect.width / 2;
    const deltaCenter = buttonCenter - containerCenter;
    const desiredLeft = Math.max(
      0,
      Math.min(
        container.scrollLeft + deltaCenter,
        container.scrollWidth - container.clientWidth
      )
    );
    if (Math.abs(container.scrollLeft - desiredLeft) > 1) {
      try {
        container.scrollTo({ left: desiredLeft, behavior: "smooth" });
      } catch (e) {
        container.scrollLeft = desiredLeft;
      }
    }
  };

  // On Bootstrap tab activation
  document.addEventListener("shown.bs.tab", (ev) => {
    const btn = ev.target;
    if (btn && btn.classList && btn.classList.contains("nav-link")) {
      scrollTabIntoView(btn);
    }
  });

  // Fallback on click (covers cases without Bootstrap event)
  document.addEventListener("click", (ev) => {
    const btn =
      ev.target &&
      ev.target.closest &&
      ev.target.closest(".tabs-project .nav-link");
    if (btn) {
      setTimeout(() => scrollTabIntoView(btn), 0);
    }
  });

  // Persist and restore scroll position per tab pane
  const storageKeyForPane = (paneSelector) => {
    const paneId = (paneSelector || "").replace("#", "");
    return "tabs-scroll:" + location.pathname + ":" + paneId;
  };
  const getPaneSelectorFromButton = (btn) => {
    if (!btn) return null;
    let sel = btn.getAttribute("data-bs-target");
    if (!sel || sel === "#") {
      const controls = btn.getAttribute("aria-controls");
      if (controls) sel = "#" + controls;
    }
    if (!sel || sel === "#") {
      const href = btn.getAttribute("href");
      if (href) {
        const hashIndex = href.lastIndexOf("#");
        if (hashIndex >= 0) sel = href.slice(hashIndex);
      }
    }
    if (!sel || sel.length < 2 || sel.charAt(0) !== "#") return null;
    return sel;
  };
  const saveScrollForButton = (btn) => {
    if (isRestoring) return;
    const paneSelector = getPaneSelectorFromButton(btn);
    if (!paneSelector) return;
    const pane = document.querySelector(paneSelector);
    if (!pane) return;
    try {
      const paneTop = pane.getBoundingClientRect().top + window.scrollY;
      const visibleTopAbs = window.scrollY + getStickyOffset();
      const relativeTopVisible = Math.max(0, visibleTopAbs - paneTop);
      const relativeTopLegacy = Math.max(0, window.scrollY - paneTop);
      const relativeCenter = Math.max(0, getVisibleCenterAbsoluteY() - paneTop);
      const anchor = getAnchorForButton(btn);
      const anchorBottomAbs = getAnchorBottomAbsoluteY(anchor);
      const relativeFromAnchor = Math.max(0, visibleTopAbs - anchorBottomAbs);
      const payload = {
        v: 4,
        rTopV: relativeTopVisible,
        rTop: relativeTopLegacy,
        rCenter: relativeCenter,
        rFromAnchor: relativeFromAnchor,
      };
      sessionStorage.setItem(
        storageKeyForPane(paneSelector),
        JSON.stringify(payload)
      );
    } catch (e) {}
  };
  const restoreScrollForButton = (btn) => {
    const paneSelector = getPaneSelectorFromButton(btn);
    if (!paneSelector) return;
    const pane = document.querySelector(paneSelector);
    if (!pane) return;
    try {
      const stored = sessionStorage.getItem(storageKeyForPane(paneSelector));
      if (stored != null) {
        let relativeFromAnchor = null;
        let relativeCenter = null;
        let relativeTop = null;
        let relativeTopVisible = null;
        try {
          const data = JSON.parse(stored);
          if (data && typeof data === "object") {
            if (data.rTopV != null) {
              const tv = Number(data.rTopV);
              if (!Number.isNaN(tv)) relativeTopVisible = tv;
            }
            if (data.rFromAnchor != null) {
              const a = Number(data.rFromAnchor);
              if (!Number.isNaN(a)) relativeFromAnchor = a;
            }
            if (data.rCenter != null) {
              const v = Number(data.rCenter);
              if (!Number.isNaN(v)) relativeCenter = v;
            }
            if (data.rTop != null) {
              const t = Number(data.rTop);
              if (!Number.isNaN(t)) relativeTop = t;
            }
          } else {
            const t = Number(stored);
            if (!Number.isNaN(t)) relativeTop = t;
          }
        } catch (_) {
          const t = Number(stored);
          if (!Number.isNaN(t)) relativeTop = t;
        }

        const paneTop = pane.getBoundingClientRect().top + window.scrollY;
        let targetY = null;
        // Prefer visible-top relative (exact match under sticky header), then pane-top legacy, then center, then nav-relative
        if (relativeTopVisible != null && relativeTopVisible > 1) {
          targetY = Math.max(
            0,
            paneTop + relativeTopVisible - getStickyOffset()
          );
        } else if (relativeTop != null && relativeTop > 1) {
          // Legacy: stored relative to viewport top; restore without subtracting offset
          targetY = Math.max(0, paneTop + relativeTop);
        } else if (relativeCenter != null) {
          const offset = getStickyOffset();
          const visibleHalf = Math.max(0, window.innerHeight - offset) / 2;
          targetY = Math.max(
            0,
            paneTop + relativeCenter - offset - visibleHalf
          );
          // Only restore relative to anchor if user actually scrolled past anchor (positive offset)
        } else if (relativeFromAnchor != null && relativeFromAnchor > 0) {
          const anchor = getAnchorForButton(btn);
          const anchorBottomAbs = getAnchorBottomAbsoluteY(anchor);
          const offset = getStickyOffset();
          targetY = Math.max(0, anchorBottomAbs + relativeFromAnchor - offset);
        } else {
          // Default: ensure the tab menu is visible right under the sticky header on first open
          const anchor = getAnchorForButton(btn);
          if (anchor) {
            const anchorTopAbs =
              anchor.getBoundingClientRect().top + window.scrollY;
            const offset = getStickyOffset();
            const anchorBottomAbs = anchorTopAbs + anchor.offsetHeight;
            const desiredY = Math.max(0, anchorBottomAbs - offset);
            // Scroll only if current viewport begins above desired content start
            if (window.scrollY < desiredY - 1) {
              targetY = desiredY;
            }
          }
        }

        if (targetY != null) {
          // Defer twice to allow layout/height changes after tab activation
          isRestoring = true;
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              // Avoid jumps when difference is small (<120px).
              if (Math.abs(window.scrollY - targetY) > 300) {
                window.scrollTo({ top: targetY, behavior: "auto" });
              }
              // release restore guard after a short delay to avoid saving jitter
              setTimeout(() => {
                isRestoring = false;
              }, 120);
            });
          });
        }
      }
    } catch (e) {}
  };

  // Save on Bootstrap hide, restore on show
  document.addEventListener("hide.bs.tab", (ev) => {
    const btn = ev.target;
    if (btn && btn.classList && btn.classList.contains("nav-link")) {
      saveScrollForButton(btn);
    }
  });
  document.addEventListener("shown.bs.tab", (ev) => {
    const btn = ev.target;
    if (btn && btn.classList && btn.classList.contains("nav-link")) {
      restoreScrollForButton(btn);
    }
  });

  // Fallback without Bootstrap events: on click, save current active and then restore clicked
  document.addEventListener("click", (ev) => {
    const clicked =
      ev.target &&
      ev.target.closest &&
      ev.target.closest(".tabs-project .nav-link");
    if (!clicked) return;
    const nav = clicked.closest(".tabs-project");
    const active = nav ? nav.querySelector(".nav-link.active") : null;
    if (active) saveScrollForButton(active);
    setTimeout(() => restoreScrollForButton(clicked), 0);
  });

  // Save active tab pane scroll on page unload as a safeguard
  window.addEventListener("beforeunload", () => {
    const active = document.querySelector(".tabs-project .nav-link.active");
    if (active) saveScrollForButton(active);
  });

  // Per-tab live saving on scroll (throttled)
  const maybeSaveActive = throttle(() => {
    if (isRestoring) return;
    const active = document.querySelector(".tabs-project .nav-link.active");
    if (!active) return;
    saveScrollForButton(active);
  }, 120);
  window.addEventListener("scroll", maybeSaveActive, { passive: true });

  // Ensure initially active tab is visible on load
  const init = () => {
    document
      .querySelectorAll(".tabs-project-sticky .tabs-project .nav-link.active")
      .forEach((btn) => {
        scrollTabIntoView(btn);
      });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
//# sourceMappingURL=new.js.map
